import React from 'react'
import OEIInput from './OEIInput'
import { doNothing } from './OEIUtils'
import OEITextInput from './OEITextInput';
import { CLIENT_NAME, EMPTY } from './Constants';

export default function EditAccountPopover(props) {
    const setClientName=(e)=>{
        props.setEditAccountData({...props.editAccountData,clientName:e})
        props.setErrors({...props.errors,error1:EMPTY})
    }
    const setClientId=(e)=>{
        props.setEditAccountData({...props.editAccountData,clientUserId:e.toLowerCase()})
        props.setErrors({...props.errors,error2:EMPTY})
    }
    const setDescription=(e)=>{
        props.setEditAccountData({...props.editAccountData,description:e})
        props.setErrors({...props.errors,error3:EMPTY})
    }
    const setOrganization=(e)=>{
        props.setEditAccountData({...props.editAccountData,organization:e})
        props.setErrors({...props.errors,error5:EMPTY})
    }
    const setContactEmail=(e)=>{
        props.setEditAccountData({...props.editAccountData,contactEmail:e})
        props.setErrors({...props.errors,error4:EMPTY})
    }
    return (
        <div>
        <OEIInput value={props.editAccountData.clientName} editAccountData={props.editAccountData} setValue={setClientName} name={CLIENT_NAME} label='Account Name' errorMessage={props.errors.error1}showError='true'></OEIInput>
        <OEIInput value={props.editAccountData.clientUserId} editAccountData={props.editAccountData} setValue={setClientId} name='clientId' label='API Client ID' errorMessage={props.error2}showError='true' ></OEIInput>
        <OEIInput value={props.editAccountData.integrationAcctId} editAccountData={props.editAccountData} setValue={doNothing} label='Integrator ID' ></OEIInput>
        <OEIInput value={props.editAccountData.organization} editAccountData={props.editAccountData} setValue={setOrganization} name='Organization' label='Organization' errorMessage={props.errors.error5}showError='true' ></OEIInput>
        <OEIInput value={props.editAccountData.contactEmail} editAccountData={props.editAccountData} setValue={setContactEmail} label='Contact Email' name ='ContactEmail' errorMessage={props.errors.error4}showError='true'></OEIInput>
        <OEITextInput value={props.editAccountData.description} editAccountData={props.editAccountData} setValue={setDescription} name='description' label='Description' errorMessage={props.errors.error3}showError='true' ></OEITextInput>
        </div>
    )
}
